// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buybox-filter[data-v-4ca0b6a8]{margin-bottom:24px}.buybox-filter__label[data-v-4ca0b6a8]{display:flex;height:40px;padding:8px 16px;border-radius:24px;background:#111924;margin-inline-end:8px;color:#6f7d90;font-size:16px;letter-spacing:.24px;border-color:transparent}.buybox-filter__label--active[data-v-4ca0b6a8]{background:#222c38;color:#fff;font-size:16px;letter-spacing:.24px}.buybox-filter__label[data-v-4ca0b6a8]:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
